const HowDoYouLikeToTravel = Object.freeze({
  SLOW_AND_RELAXED: 'slow_and_relaxed',
  BALANCED: 'balanced',
  BUSY_AND_ACTIVE: 'busy_and_active',
  NON_STOP_ADVENTURE: 'non_stop_adventure',
} as const);

export type HowDoYouLikeToTravel = (typeof HowDoYouLikeToTravel)[keyof typeof HowDoYouLikeToTravel];
export const allHowDoYouLikeToTravel: [HowDoYouLikeToTravel, ...HowDoYouLikeToTravel[]] = Object.values(HowDoYouLikeToTravel) as [HowDoYouLikeToTravel, ...HowDoYouLikeToTravel[]];

export default HowDoYouLikeToTravel;